import React, { FunctionComponent } from 'react';
import styles from './DonationReminder.scss';
import { useApp } from '../../hooks/useApp';
import { MODAL } from '../../context';
import { useTranslation } from 'react-i18next';
import { useBasePageQuery, useFlags } from '../../hooks';
import { useEvent } from '../EventDetails/useEvent';
import { PageType } from '../../../types/__generated__';

// OTG 2023 - Tom Hedges

export const DonationReminder: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { showModal } = useApp();
  const { data } = useBasePageQuery();
  const { event } = useEvent();

  const { showFrpSetReminderButton } = useFlags();
  if (!showFrpSetReminderButton) return null;

  const eventDate = event?.startDate || data?.page?.activity?.date;

  if (
    data?.page?.type === PageType.Team ||
    !eventDate ||
    new Date(eventDate) < new Date()
  ) {
    return null;
  }

  return (
    <button
      onClick={() => showModal({ modal: MODAL.DONATION_REMINDER })}
      className={`jg-text--link ${styles.reminderButton}`}
      data-qa="donation-reminder-button"
    >
      {t('donationReminder.setReminder')}
    </button>
  );
};
